
import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import CallFlowVisualizer from '../components/CallFlowVisualizer';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="animate-fade-in overflow-hidden">
      {/* 01. HERO_NODE */}
      <Hero />

      {/* 02. SYSTEM_VISUALIZATION (Interactive Infographic) */}
      <section className="py-16 sm:py-32 bg-black/50 border-y border-white/5 overflow-hidden">
        <div className="container mx-auto px-6 text-center mb-10 sm:mb-20">
          <div className="mono text-[10px] sm:text-[11px] font-black text-[#32dee6] tracking-[0.4em] sm:tracking-[0.5em] uppercase mb-4 sm:mb-6 animate-fade-in">Architecture_Visualizer</div>
          <h2 className="text-4xl sm:text-7xl md:text-8xl font-black text-white uppercase tracking-tighter mb-4 sm:mb-8 leading-none">YOUR NEW 24/7 DISPATCHER.</h2>
          <p className="text-lg sm:text-2xl text-gray-400 font-light max-w-4xl mx-auto leading-relaxed">
            We handle the noise so you can handle the tools.
          </p>
        </div>
        <CallFlowVisualizer />
      </section>
      
      {/* 03. CORE_CAPABILITIES */}
      <Services />

      {/* 04. IMPLEMENTATION_LOGIC */}
      <HowItWorks />

      {/* 05. SUCCESS_METRICS */}
      <Testimonials />

      {/* 06. FINAL_INITIALIZATION */}
      <section className="py-24 sm:py-52 px-6 bg-black relative overflow-hidden border-t border-white/5">
        <div className="absolute inset-0 bg-gradient-to-b from-[#1d3fc4]/5 to-transparent"></div>
        <div className="glow-spot -bottom-64 left-1/2 -translate-x-1/2 opacity-20"></div>
        <div className="absolute inset-0 grid-pattern opacity-[0.05]"></div>
        
        <div className="container mx-auto max-w-5xl text-center relative z-10 space-y-8 sm:space-y-12">
          <div className="mono text-[10px] sm:text-[11px] font-black text-[#32dee6] tracking-[0.5em] sm:tracking-[0.6em] uppercase animate-pulse">
            INFRASTRUCTURE_READY
          </div>
          
          <h2 className="text-5xl sm:text-7xl md:text-[10rem] font-black tracking-tighter leading-none text-white uppercase">
            DEPLOY<span className="text-[#32dee6]">.</span>
          </h2>
          
          <p className="text-lg sm:text-2xl text-gray-400 font-light max-w-2xl mx-auto leading-relaxed">
            Own your business's voice. Deploy the FrontDesk AI Voice Receptionist and capture every opportunity without human limits.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 pt-8 sm:pt-12">
            <Link 
              to="/contact" 
              className="w-full sm:w-auto px-10 py-5 sm:px-14 sm:py-6 bg-[#1d3fc4] text-white font-black uppercase tracking-[0.2em] text-xs rounded-2xl hover:bg-[#32dee6] hover:text-black transition-all shadow-2xl shadow-blue-900/40 transform hover:-translate-y-1"
            >
              Start Audit
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;